export default __webpack_public_path__ + "static/media/brand-image-01.00c84e3d.jpg";